import UserApi from 'api/user'

const USER_GET = 'USER_GET'
const USER_DESTROY = 'USER_DESTROY'
const WX_CONNECTION_SET = 'WX_CONNECTION_SET'
const WX_CONNECTION_CHECKID_SET = 'WX_CONNECTION_CHECKID_SET'

// initial state
const state = {
  info: {
    id: null
  },
  wxConnection: {
    connected: false
  },
  wxConnectionCheckID: null
}

const getters = {
  organization: state => {
    return state.info.organizations && state.info.organizations.length > 0 ? state.info.organizations[0] : null
  },
  session: state => {
    return state.info.id
  }
}

const mutations = {
  [USER_GET](state, { user }) {
    state.info = user
  },
  [USER_DESTROY](state) {
    state.info = { id: null }
  },
  [WX_CONNECTION_SET](state, params) {
    state.wxConnection = params
  },
  [WX_CONNECTION_CHECKID_SET](state, cid) {
    state.wxConnectionCheckID = cid
  }
}

// actions
const actions = {
  // get user profile
  get({ dispatch, state, commit }, params = {}) {
    let _user = null
    if (state.info.id) {
      _user = state.info
    }

    let force = params.force || false

    return new Promise((resolve, reject) => {
      if (_user && !force) {
        resolve(_user)
      } else {
        UserApi.show().then(res => {
          commit(USER_GET, { user: res.data })

          if (res.data.source === 'tbc') {
            dispatch('set_tbc_mode', true, { root: true })
          }

          // after get user, get its quotas, since it is related
          dispatch('quota/index', { force: true }, { root: true }).then(_ => {
            resolve(res.data)
          })
        }).catch(err => {
          if (err && err.response && err.response.status === 401) {
            commit(USER_GET, { user: { id: false } })
            resolve(false)
          } else {
            reject(err)
          }
        })
      }
    })
  },

  // update user profile
  update({ dispatch, commit }, params) {
    return UserApi.update(params).then(res => {
      commit(USER_GET, { user: res.data })
      dispatch('quota/index', { force: true }, { root: true })
    })
  },

  // send captcha request
  captcha(state, params) {
    return UserApi.captcha(params)
  },

  // User sign-in
  signIn({ commit, dispatch }, params) {
    return UserApi.signIn(params).then((res) => {
      commit(USER_GET, { user: res.data.user })
      dispatch('quota/index', { force: true }, { root: true })
    })
  },

  // User sign_out
  signOut({ commit }, params) {
    return UserApi.signOut().then(() => {
      commit(USER_DESTROY)
      commit('quota/QUOTA_CLEAN', null, { root: true })
    })
  },

  // User sign-up
  signUp({ commit, dispatch }, params) {
    return UserApi.signUp(params).then((res) => {
      commit(USER_GET, { user: res.data.user })
      dispatch('quota/index', { force: true }, { root: true })
    })
  },

  // 修改密码
  changePassword({ state }, params) {
    return UserApi.changePassword(params)
  },

  // 请求重置密码
  reqResetPassword(_, params) {
    return UserApi.reqResetPassword(params)
  },

  // 重置密码
  resetPassword({ commit, dispatch }, params) {
    return UserApi.resetPassword(params).then(res => {
      commit(USER_GET, { user: res.data.user })
      dispatch('quota/index', { force: true }, { root: true })
    })
  },

  // mp connection
  wxConnection({ state, commit, dispatch }) {
    return UserApi.wxConnection().then((res) => {
      let connected = res.data.connected

      if (state.info.wechat_mp_connected !== connected) {
        dispatch('get', { force: true })
      }

      commit(WX_CONNECTION_SET, res.data)

      let clearCheckID = () => {
        if (state.wxConnectionCheckID) {
          window.clearTimeout(state.wxConnectionCheckID)
          commit(WX_CONNECTION_CHECKID_SET, null)
        }
      }

      // since wxConnection might expire
      if (!connected) {
        // 前端提前一分钟刷新
        let interval = (res.data.expired_at * 1000 - Date.now()) - 60 * 1000

        clearCheckID()
        commit(WX_CONNECTION_CHECKID_SET, window.setTimeout(() => {
          dispatch('wxConnection')
        }, interval))
      } else {
        clearCheckID()
      }
    })
  },

  // wx auth params
  wxAuth() {
    return UserApi.wxAuth()
  },

  // wx disconnect
  wxDisconnect({ dispatch }) {
    return UserApi.wxDisconnect().then(_ => {
      dispatch('get', { force: true })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js